module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Deborah Blake\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_c('B', [_vm._v("Deborah Blake")]), _vm._v(" is the author of seventeen books on modern Witchcraft, including "), _c('I', [_vm._v("The Eclectic Witch's Book of Shadows")]), _vm._v(", "), _c('I', [_vm._v("The Little Book of Cat Magic")]), _vm._v(", and "), _c('I', [_vm._v("Llewellyn's Little Book of Spellcraft")]), _vm._v(", as well as the acclaimed "), _c('I', [_vm._v("Everyday Witch Tarot")]), _vm._v(", "), _c('I', [_vm._v("Everyday Witch Oracle")]), _vm._v(", and "), _c('I', [_vm._v("Everyday Witch’s Familiars Oracle")]), _vm._v(". She has also written three paranormal romance and urban fantasy series for Berkley, and as well as a cozy mystery series about a run-down pet rescue. Deborah lives in a 140-year-old farmhouse in upstate New York with numerous cats who supervise all her activities, both magical and mundane. She can be found at DeborahBlakeAuthor.com.")], 1)], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/pZ7f7K/tc-custom/9780738774886.jpg?1741985490230",
      "alt": "This image is the cover for the book Llewellyn's Little Book of Witchcraft"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Llewellyn's Little Book of Witchcraft\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Brimming with nearly seventy spells, tips, and activities, this illustrated book helps you take new steps on your personal journey into witchcraft. Award-winning author Deborah Blake teaches you how to build an altar, use divination tools, invoke deities, and much more. Covering a wide range of magical goals, this little book will help you improve your relationships, deepen your connection to nature, and live a successful, enchanted life.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Llewellyn Publications is an imprint of Llewellyn Worldwide Ltd.\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0